import cn from 'classnames';
import type { ReactNode } from 'react';
import styles from './scrollable-content-footer.module.css';

export type ScrollableContentFooterProperties = {
  children?: ReactNode;
  className?: string;
  paddingBottom?: boolean;
  paddingTop?: boolean;
};

const ScrollableContentFooter = ({
  children,
  className,
  paddingBottom = true,
  paddingTop = true,
}: ScrollableContentFooterProperties) => (
  <div
    className={cn(
      className,
      styles.footer,
      { [styles['footer--padding-bottom'] ?? '']: paddingBottom },
      { [styles['footer--padding-top'] ?? '']: paddingTop },
    )}
  >
    {children}
  </div>
);

export default ScrollableContentFooter;
